<template>
  <v-app class="bg-white">
    <div class="content">
      <v-container>
        <v-row no-gutters align="center" justify="center">
          <v-col cols="12" v-for="product in cart" :key="product">
            <v-card variant="flat" rounded="xl" class="text-center">
              <v-card :ripple="false" variant="text">
                <v-card-actions  height="400px">
                  <v-row>
                    <v-col cols="12">
                      <v-img height="150px" :src="product.logo_url"></v-img>
                    </v-col>
                  </v-row>
                </v-card-actions>
                <v-card-text height="400px">
                  <h6>{{product.title.slice(0, 17)}}</h6>
                  <h6>{{product.title.slice(0, 17)}}</h6>
                  <div style="font-size: 12px" v-if="product.title.length > 25">
                    {{product.title.slice(0, 25)}}...
                  </div>
                  <div style="font-size: 12px" v-else>
                    {{product.title.slice(0, 25)}}
                  </div>

                  <v-sheet height="10px"></v-sheet>
                  <b style="font-size: 12px">{{product.price}} RUB</b>

                  <v-sheet height="10px"></v-sheet>
                  <b style="font-size: 12px">{{product.size}}</b>
                </v-card-text>
              </v-card>
            </v-card>
            <hr>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <bottom-nav-component btn_3_color="black" >
    </bottom-nav-component>


  </v-app>

</template>

<script>
import axios from "axios";
import store from "../store";
import BottomNavComponent from "@/components/BottomNavComponent.vue";

export default {
  name: "HomePage",
  computed: {
    store() {
      return store
    },
    filteredBrands() {
      return this.brands.filter(brand =>
          brand.toLowerCase().includes(this.search_query.toLowerCase())
      );
    },
  },
  components: {
    BottomNavComponent,
  },
  data: () => ({
    brands: ["Nike", "Tom Ford", "Adidas", "Tommy Hilfiger", "Puma", "Reebok"],
    search_query: "",
    keyword: "string",
    on_search: false,
    cart: [
      {
        id: 0,
        title: "null",
        price: 0,
        logo_url: null,
        size: "null",
        count: 0
      }
    ],
    genders: ["Унисекс", "Мужское", "Женское", "Детское"],
    gender: 0,
    fitId: [],
    current_page: 1,
    per_page: 6,
    info_items: ["./img_9.webp", "./img_10.webp"],
  }),
  mounted() {
    window.Telegram.WebApp.BackButton.show()
    window.Telegram.WebApp.onEvent('backButtonClicked', () => {
      this.$router.push({ name: 'Home', });
    })

    if (!store.state.loaded) {
      this.checkInitData({_auth: window.Telegram.WebApp.initData})
    }
  },
  beforeUnmount () {
    window.Telegram.WebApp.BackButton.hide()
    window.Telegram.WebApp.BackButton.offClick()
  },
  methods: {
    checkInitData(data) {
      axios.post('api/v1/check-init-data/', data)
          .then(response => {
            this.$store.commit("setStateProperty", {
              property: "user", value: response.data.user
            })
            this.loadData(response.data.user.id)
          })
          .catch(error => {
            console.error(error);
          });
    },
    loadData(user_id) {
      this.getCart(user_id)
      this.$store.commit("setStateProperty", {
        property: "loaded", value: true
      })
      window.Telegram.WebApp.ready()
    },
    getCart(user_id) {
      axios.get('api/v1/cart/get', {
        params: {user_id: user_id},
      }).then(response => {
        this.cart = response.data.products
        this.$store.commit("setStateProperty", {
          property: "loaded", value: true
        })
      }).catch(error => {
        console.error(error);
      });
    },

  }
}
</script>

<style scoped>

@import url('https://fonts.cdnfonts.com/css/sf-pro-display');

html, body {
  font-family: 'SF Pro', sans-serif !important;
  color: black;
  background: white !important;
  touch-action: manipulation !important;
}

.pre-subtitle {
  white-space: pre-line !important;
}

</style>